// AUTO GENERATED FILE - Changes WILL be lost.
// pt - used as 'pt' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Boletim de apostas",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Colocar aposta",
  "betslip.clear": "Limpar tudo",
  "betslip.clearResult": "Limpar",
  "betslip.noSelections": "Adicione seleções para começar a apostar",
  "betslip.notLoggedIn": "Faça login para começar a apostar",
  "betslip.refresh": "Atualizar",
  "betslip.totalStake": "Aposta total",
  "betslip.noHistoryData": "Nenhuma informação de aposta disponível",
  "betslip.openBets": "Apostas abertas",
  "betslip.betHistory": "Histórico de Apostas",
  "betslip.betHistoryWon": "Vencida",
  "betslip.betHistoryLost": "Perdida",
  "loading.loading": "Carregando",
  "loading.account": "Carregando Conta",
  "loading.league": "Carregando Liga",
  "loading.gameweeks": "Carregando Semanas do Jogo",
  "loading.markets": "Carregando Mercados",
  "loading.bethistory": "Carregando histórico de apostas",
  "login.loginRequired": "É necessário fazer login",
  "login.loginToBet": "Faça login para começar a apostar",
  "navigation.back": "Voltar",
  "navigation.close": "Fechar",
  "video.liveStreamAvailable": "Transmissão ao vivo disponível",
  "video.logInToWatch": "Faça login para assistir",
  "error.error": "Erro",
  "error.404": "Página não Encontrada",
  "error.gameLaunchFailed": "Não foi possível iniciar o jogo",
  "error.unknownErrorCode": "Erro desconhecido: {code}",
  "error.minUnitStakeLimitExceeded": "A aposta mínima é {limit}",
  "error.maxUnitStakeLimitExceeded": "A aposta máxima é {limit}",
  "error.minTotalStakeLimitExceeded": "A aposta total mínima é {limit}",
  "error.maxTotalStakeLimitExceeded": "A aposta total máxima é {limit}",
  "error.notPlaced": "Não Apostado",
  "error.wagerDisallowed": "Aposta não permitida",
  "error.errorEventIsOff": "O evento começou",
  "multiplebet.Singles": "Simples",
  "multiplebet.Doubles": "Duplas",
  "multiplebet.Trebles": "Triplas",
  "multiplebet.Accumulator": "Acumulada",
  "multiplebet.Perm 4-Folds": "4 - Múltiplas",
  "multiplebet.Perm 5-Folds": "5 - Múltiplas",
  "multiplebet.Perm 6-Folds": "6 - Múltiplas",
  "multiplebet.Perm 7-Folds": "7 - Múltiplas",
  "multiplebet.Perm 8-Folds": "8 - Múltiplas",
  "multiplebet.Perm 9-Folds": "9 - Múltiplas",
  "nomorebets": "Não há mais apostas",
  "playtime": "Tempo de Jogo",
  "gameId": "ID do Jogo",
  "noGames": "Não há jogos disponíveis. Verifique em breve.",
  "Home": "Casa",
  "Away": "Visitante",
  "Visitor": "Visitante",
  "soccerbet.gameWeek": "JOGO DA SEMANA",
  "soccerbet.noGameWeeks": "Não há semanas de jogo disponíveis. Verifique em breve.",
  "soccerbet.league": "Classificação da Liga",
  "soccerbet.table.name": "Name",
  "soccerbet.table.won": "V",
  "soccerbet.table.drawn": "E",
  "soccerbet.table.lost": "D",
  "soccerbet.table.points": "PT",
  "market.abbr.Both Teams To Score": "BTTS",
  "market.Both Teams To Score": "Ambos Times Marcam",
  "market.Over / Under": "Máais de/Menos de",
  "market.Double Chance": "Dupla Chance",
  "market.Match Result": "Resultado da Partida",
  "market.Exact Goals": "Gols Exatos",
  "market.Correct Score": "Resultado Correto",
  "market.Match Result Both Score": "Resultado do Jogo Ambos Marcam",
  "market.Result Und/Over 1.5 Total Goals": "Resultado Mais de/Menos de 1.5 gols totais",
  "market.Result Und/Over 2.5 Total Goals": "Resultado Mais de/Menos de 2.5 gols totais",
  "market.Under Over 1.5 Total Goals": "Mais de/Menos de 1.5 gols em total",
  "market.Under Over 2.5 Total Goals": "Mais de/Menos de 2.5 gols em total",
  "market.Under Over 3.5 Total Goals": "Mais de/Menos de 3.5 gols em total",
  "market.Under Over 4.5 Total Goals": "Mais de/Menos de 4.5 gols totais",
  "market.Total Goals 1 To 2": "Total de Gols 1 a 2",
  "market.Total Goals 1 To 3": "Total de Gols 1 a 3",
  "market.Total Goals 1 To 4": "Total de Gols 1 a 4",
  "market.Total Goals 2 To 3": "Total de Gols 2 a 3",
  "market.Total Goals 2 To 4": "Total de Gols 2 a 4",
  "market.Under Over 1.5 Home Goals": "Mais de/Menos de 1.5 gols em casa",
  "market.Under Over 1.5 Away Goals": "Mais de/Menos de 1.5 gols do visitante",
  "market.Home Team Exact Goals": "Time em Casa Exatos Gols",
  "market.Away Team Exact Goals": "Time Visitante Exatos Gols",
  "selection.Yes": "Sim",
  "selection.No": "Não",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Sim",
  "selection.1+No": "1+Não",
  "selection.X+Yes": "X+Sim",
  "selection.X+No": "X+Não",
  "selection.2+Yes": "2+Sim",
  "selection.2+No": "2+Não",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}"
}
